export default {
    name: 'HeaderResume',

    props: {
        fields: {
            type: Array,
            required: true
        },
        loading: {
            type: Boolean,
            default: false
        }
    }
};
